<template>
  <div class="accordion-item">
    <div class="accordion-header">
      <div class="main-section" @click="open = !open">
        <span class="header-label">{{ label }}</span>
        <!--        <div
          class="accordion-caret"
          :class="{ 'accordion-caret-active': open }"
        />-->
      </div>
      <slot name="accordionTitleExtraContent" />
    </div>
    <div class="accordion-body" :class="{ 'accordion-body-active': open }">
      <slot name="accordionBodyContent" />
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeAccordion",
  props: {
    label: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      open: false
    };
  }
};
</script>

<style scoped>
.accordion-item {
  width: 100%;
  height: 100%;
}

.accordion-header {
  width: 100%;
  padding: 15px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #f9f9f9;
  cursor: pointer;
}

.accordion-header .main-section {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.accordion-header .header-label {
  color: #515358;
  font-size: 12px;
  font-weight: 300;
  text-transform: uppercase;
  letter-spacing: 0.28px;
}

.accordion-caret {
  background-image: linear-gradient(to top right, transparent 50%, #515358 50%);
  width: 9px;
  height: 9px;
  margin-right: 15px;
  transform: rotate(45deg);
}

.accordion-caret-active {
  transform: rotate(135deg);
}

.accordion-body {
  background-color: #fafbfc;
  max-height: 0;
  transition: 0.5s ease-out;
  overflow: hidden;
  opacity: 0;
  text-align: left;
}

.accordion-body-active {
  opacity: 1;
  max-height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/HomeAccordion.vue